import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { QuickActionType } from "../types";
import { useBrandQuickActions } from "./useBrandQuickActions";
import { useRetailerQuickActions } from "./useRetailerQuickActions";
export var useModalContent = function useModalContent() {
  var _quickActions$QuickAc, _quickActions$QuickAc2, _quickActions$QuickAc3, _quickActions$QuickAc4, _quickActions$QuickAc5, _quickActions$QuickAc6, _quickActions$QuickAc7, _quickActions$QuickAc8;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var retailerQuickActions = useRetailerQuickActions();
  var brandQuickActions = useBrandQuickActions();
  var quickActions = _objectSpread(_objectSpread({}, retailerQuickActions), brandQuickActions);
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, QuickActionType.ACCEPT_AN_ORDER, {
    title: (_quickActions$QuickAc = quickActions[QuickActionType.ACCEPT_AN_ORDER]) === null || _quickActions$QuickAc === void 0 ? void 0 : _quickActions$QuickAc.label,
    description: strictLocalize({
      id: "ou6wIg",
      defaultMessage: [{
        "type": 0,
        "value": "Accetta nuovi ordini indicando un preventivo di spedizione"
      }]
    }),
    buttonText: strictLocalize({
      id: "5e09EO",
      defaultMessage: [{
        "type": 0,
        "value": "Fornisci un preventivo per la spedizione"
      }]
    })
  }), QuickActionType.REQUEST_COMMISSION_CHANGE, {
    title: (_quickActions$QuickAc2 = quickActions[QuickActionType.REQUEST_COMMISSION_CHANGE]) === null || _quickActions$QuickAc2 === void 0 ? void 0 : _quickActions$QuickAc2.label,
    description: strictLocalize({
      id: "rAF6ME",
      defaultMessage: [{
        "type": 0,
        "value": "Richiedi un aggiornamento della commissione di Faire Direct sugli ordini dei rivenditori con cui hai un rapporto di vendita all'ingrosso."
      }]
    }),
    buttonText: strictLocalize({
      id: "cX24dx",
      defaultMessage: [{
        "type": 0,
        "value": "Avvia richiesta di aggiornamento della commissione"
      }]
    })
  }), QuickActionType.EDIT_ITEM_AVAILABILITY, {
    title: (_quickActions$QuickAc3 = quickActions[QuickActionType.EDIT_ITEM_AVAILABILITY]) === null || _quickActions$QuickAc3 === void 0 ? void 0 : _quickActions$QuickAc3.label,
    description: strictLocalize({
      id: "b1DBx0",
      defaultMessage: [{
        "type": 0,
        "value": "Aggiorna la disponibilità per gli articoli negli ordini non evasi"
      }]
    }),
    buttonText: strictLocalize({
      id: "zkYVp5",
      defaultMessage: [{
        "type": 0,
        "value": "Modifica la disponibilità degli articoli"
      }]
    })
  }), QuickActionType.CANCEL_AN_ORDER, {
    title: (_quickActions$QuickAc4 = quickActions[QuickActionType.CANCEL_AN_ORDER]) === null || _quickActions$QuickAc4 === void 0 ? void 0 : _quickActions$QuickAc4.label,
    description: strictLocalize({
      id: "uw/QeA",
      defaultMessage: [{
        "type": 0,
        "value": "Annulla un ordine che non è stato ancora evaso o spedito"
      }]
    }),
    buttonText: strictLocalize({
      id: "sPg2u4",
      defaultMessage: [{
        "type": 0,
        "value": "Avvia l'annullamento"
      }]
    })
  }), QuickActionType.TRACK_AN_ORDER, {
    title: (_quickActions$QuickAc5 = quickActions[QuickActionType.TRACK_AN_ORDER]) === null || _quickActions$QuickAc5 === void 0 ? void 0 : _quickActions$QuickAc5.label,
    description: strictLocalize({
      id: "vvqBDw",
      defaultMessage: [{
        "type": 0,
        "value": "Visualizza i dettagli di tracciabilità per gli ordini spediti"
      }]
    }),
    buttonText: strictLocalize({
      id: "uVSNXI",
      defaultMessage: [{
        "type": 0,
        "value": "Traccia ordine"
      }]
    })
  }), QuickActionType.RETURN_ITEMS, {
    title: (_quickActions$QuickAc6 = quickActions[QuickActionType.RETURN_ITEMS]) === null || _quickActions$QuickAc6 === void 0 ? void 0 : _quickActions$QuickAc6.label,
    description: strictLocalize({
      id: "SM+WKr",
      defaultMessage: [{
        "type": 0,
        "value": "Restituisci articoli di ordini ricevuti negli ultimi 60 giorni. Solo il tuo primo ordine da un brand specifico è restituibile."
      }]
    }),
    buttonText: strictLocalize({
      id: "ylvEif",
      defaultMessage: [{
        "type": 0,
        "value": "Avvia un reso"
      }]
    })
  }), QuickActionType.CONTACT_A_BRAND, {
    title: (_quickActions$QuickAc7 = quickActions[QuickActionType.CONTACT_A_BRAND]) === null || _quickActions$QuickAc7 === void 0 ? void 0 : _quickActions$QuickAc7.label,
    description: strictLocalize({
      id: "Tce2uo",
      defaultMessage: [{
        "type": 0,
        "value": "Contatta i brand per domande specifiche sul prodotto o per dubbi sulla tempistica di un ordine. Questo è il modo migliore e più veloce per risolvere le questioni in sospeso."
      }]
    }),
    buttonText: strictLocalize({
      id: "jHHKwS",
      defaultMessage: [{
        "type": 0,
        "value": "Contatta il brand"
      }]
    })
  }), QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS, {
    title: (_quickActions$QuickAc8 = quickActions[QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS]) === null || _quickActions$QuickAc8 === void 0 ? void 0 : _quickActions$QuickAc8.label,
    description: strictLocalize({
      id: "95bnr6",
      defaultMessage: [{
        "type": 0,
        "value": "Segnala i problemi relativi al tuo ordine entro 14 giorni dalla consegna"
      }]
    }),
    buttonText: strictLocalize({
      id: "EfYP7O",
      defaultMessage: [{
        "type": 0,
        "value": "Avvia segnalazione prodotti danneggiati/mancanti"
      }]
    })
  });
};